import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";


import { FormlyView } from "../FormlyView";

export class DevelopmentProduct extends FormlyView {

    constructor(
        fieldDefinition: FieldDefinition,
        form: FormGroup,
        model: {},
    ) {
        super(form, 
            [   ...fieldDefinition.developmentSenderFields,
                ...fieldDefinition.developmentPresentationNameFields], model);

            
    }

}